<template>
  <div class="container">
    <div class="contact">
      <div class="title">联系我们</div>
      <div class="content">咨询电话： 0571-87719636</div>
      <div class="content">人力资源： 0571-87719636</div>
      <div class="content">商务合作： mashunh@bsfit.com.cn</div>
      <div class="content">总部地址： 浙江省杭州市滨江区华创大厦14楼</div>
    </div>
    <div class="footer">
      copyright © 2015-2021 杭州邦睿科技有限公司 浙ICP备16036196号-1
      <img
        src="@/assets/gbeian.png"
        alt=""
        style="
          width: 20px;
          height: 20px;
          display: inline-block;
          margin-left: 6px;
        "
      />浙公网安备 33010802007551号
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "br-footer",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
  
  <style scoped lang="less">
.container {
  .contact {
    box-sizing: border-box;
    padding: 0 160px;
    width: 100vw;
    height: 240px;
    padding-top: 30px;
    text-align: center;
    .title {
      font-size: 18px;
      color: #3e3e3e;
      margin-bottom: 23px;
    }
    .content {
      font-size: 14px;
      color: #7c7c7c;
      margin-top: 15px;
    }
  }
  .footer {
    width: 100vw;
    height: 70px;
    background-color: #0c6fb5;
    font-family: "Microsoft YaHei";
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
  